import React, {Fragment} from 'react';
import Illustration from './illustration.svg';
import {Next, Link} from 'components';
import {config} from 'helpers';

export function Intro() {
  return (
    <Fragment>
      <p>Start by completing a short clarity and focus quiz. Then let the { config.appName } quide you through a step-by-step process of identifying your goals and creating an action plan to achieve them.</p>
      <p style={{ padding: '1em 20%'  }}>
        <Illustration />
      </p>
      <p className="text-center">
        <Next className="primary">Start</Next>
      </p>
      <p className="text-center">
        <Link className="link" to="/">Skip</Link>
      </p>
    </Fragment>
  );
}

